import { useEffect, useRef } from 'react';
import { useSocket } from '@/contexts/websockets/websocket-provider';

export function useSocketEvent<T = unknown>(
  event: string,
  handler: (data: T) => void,
  enabled = true,
) {
  const { socket } = useSocket();
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!socket || !enabled) {
      return;
    }

    const listener = (raw: unknown) => {
      let data: T;

      if (typeof raw === 'string') {
        try {
          data = JSON.parse(raw) as T;
        } catch {
          data = raw as T;
        }
      } else {
        data = raw as T;
      }

      handlerRef.current(data);
    };

    socket.on(event, listener);

    return () => {
      socket.off(event, listener);
    };
  }, [socket, event, enabled]);
}
